import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";
import { GameItem } from "../base/baseType";

/** 搜索组件属性接口 */
export type StochasticGameAttrs = BaseComponentAttrs;

/** 搜索组件类 */
export class StochasticGameComponent extends BaseComponent<StochasticGameAttrs> {
  constructor(data: Partial<BaseComponent<StochasticGameAttrs>> = {}) {
    super(data);
    this.type = CompType.stochastic_game;
  }
  /** 获取游戏列表 */
  public getGames(): GameItem[] {
    return (this.lang_attrs?.list as GameItem[]) || [];
  }
}
